import {
  ProfileSyncResponseSchema as ProfileSyncResponseSchemaInternal,
  ProfileSyncSnapshotResponseSchema as ProfileSyncSnapshotResponseSchemaInternal,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export const ProfileSyncResponseSchema = ProfileSyncResponseSchemaInternal;

export type ProfileSyncResponseInput = z.input<typeof ProfileSyncResponseSchema>;
export type ProfileSyncResponseOutput = z.output<typeof ProfileSyncResponseSchema>;

export function serializeProfileSyncResponse(payload: ProfileSyncResponseInput): ProfileSyncResponseOutput {
  return ProfileSyncResponseSchema.parse(payload);
}

export type ProfileSyncSnapshotResponseInput = z.input<typeof ProfileSyncSnapshotResponseSchemaInternal>;
export type ProfileSyncSnapshotResponseOutput = z.output<typeof ProfileSyncSnapshotResponseSchemaInternal>;

export function serializeProfileSyncSnapshotResponse(
  payload: ProfileSyncSnapshotResponseInput
): ProfileSyncSnapshotResponseOutput {
  return ProfileSyncSnapshotResponseSchemaInternal.parse(payload);
}
